import { type ClientContext, ContextClient } from '~/services/contextClient';
import AgentsClientFactory from './agentsClient.factory';
import type { AgentsClientInterface, Agent } from './agentsClient.types';
import type { AxiosPromise } from 'axios';

class AgentsClient extends ContextClient<AgentsClientInterface> {
    constructor() {
        super(AgentsClientFactory);
    }

    getAgents(context: ClientContext): AxiosPromise<Agent[]> {
        const client = this.getClient(context);
        return client.getAgents();
    }
}

export default new AgentsClient();
